import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/SimpleList/simple-list';
export var SimpleListGroup = function SimpleListGroup(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$title = _a.title,
      title = _a$title === void 0 ? '' : _a$title,
      _a$titleClassName = _a.titleClassName,
      titleClassName = _a$titleClassName === void 0 ? '' : _a$titleClassName,
      _a$id = _a.id,
      id = _a$id === void 0 ? '' : _a$id,
      props = __rest(_a, ["children", "className", "title", "titleClassName", "id"]);

  return React.createElement("section", Object.assign({
    className: css(styles.simpleListSection)
  }, props), React.createElement("h2", {
    id: id,
    className: css(styles.simpleListTitle, titleClassName),
    "aria-hidden": "true"
  }, title), React.createElement("ul", {
    className: css(className),
    "aria-labelledby": id
  }, children));
};